import { Badge } from "@babackapp/customer-ui/components/badge";
import { Label } from "@babackapp/customer-ui/components/label";
import {
  Option,
  OptionAction,
  OptionDescription,
  OptionIcon,
  OptionTitle,
} from "@babackapp/customer-ui/components/option";
import { RadioGroupItem } from "@babackapp/customer-ui/components/radio-group";
import { Skeleton } from "@babackapp/customer-ui/components/skeleton";
import { StarFilledIcon } from "@radix-ui/react-icons";
import { RefreshCcw } from "lucide-react";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import { useDiscountOption } from "../../hooks/use-discount-option";

export function DiscountOption() {
  const t = useCustomText();
  const { bonusText, validityText, feeText, amountText, isFeeLoading, isDisabled } =
    useDiscountOption();

  return (
    <Label htmlFor="discount-type">
      <Option data-disabled={isDisabled || undefined}>
        <OptionIcon>
          <RefreshCcw />
        </OptionIcon>
        <OptionTitle>
          {t("discountOption.title")}
          <Badge variant="recomended">
            {t("discountOption.recommended")} <StarFilledIcon />
          </Badge>
          {bonusText && <Badge variant="secondary">{bonusText}</Badge>}
        </OptionTitle>
        <OptionDescription>
          {isFeeLoading ? (
            <span className="flex flex-col gap-1.5">
              <Skeleton className="h-3 w-48" />
              <Skeleton className="h-3 w-32" />
            </span>
          ) : feeText ? (
            t("discountOption.descriptionWithFee", { fee: feeText })
          ) : (
            t("discountOption.description")
          )}
          {!isFeeLoading && validityText && (
            <span className="block text-xs mt-0.5 opacity-75">{validityText}</span>
          )}
        </OptionDescription>
        <OptionAction className="justify-end gap-3">
          <span className="font-sans text-base tabular-nums whitespace-nowrap">
            {amountText}
          </span>
          <RadioGroupItem value="discount-code" id="discount-type" disabled={isDisabled} />
        </OptionAction>
      </Option>
    </Label>
  );
}
